import { ITrackingProgressBar } from "@hooks/dtos/ITrackingDTO";
import {
  FaCalendarCheck,
  FaFileAlt,
  FaHome,
  FaPlane,
  FaTruck,
} from "react-icons/fa";
import { Fragment } from "react/jsx-runtime";

interface IProps {
  steps: ITrackingProgressBar[];
}

export const TrackingProgressBar = ({ steps }: IProps) => {
  const iconMap: Record<string, JSX.Element> = {
    created: <FaCalendarCheck />,
    sent: <FaPlane />,
    document: <FaFileAlt />,
    truck: <FaTruck />,
    delivered: <FaHome />,
  };

  return (
    <div className="row mb-5">
      <div className="col-12">
        <div className="position-relative">
          {/* Vertical progress line (mobile only) */}
          <div
            className="position-absolute d-md-none"
            style={{
              top: 0,
              left: "50%",
              transform: "translateX(-50%)",
              width: "2px",
              height: "100%",
              backgroundColor: "#e0e0e0",
              opacity: 0.25,
              zIndex: 0,
            }}
          />

          {/* Steps container - Desktop */}
          <div className="d-none d-md-block">
            {/* Icons and lines row */}
            <div className="d-flex align-items-center justify-content-between mb-3">
              {steps.map((step, index) => (
                <Fragment key={`step-${index}`}>
                  {/* Step icon */}
                  <div
                    key={`icon-${index}`}
                    className="d-inline-flex align-items-center justify-content-center rounded-circle fs-2"
                    style={{
                      width: "4rem",
                      height: "4rem",
                      backgroundColor: step.color,
                      color: "white",
                      zIndex: 2,
                      flex: "0 0 auto",
                    }}
                  >
                    {iconMap[step.iconName]}
                  </div>

                  {/* Connecting line (not after last step) */}
                  {index < steps.length - 1 && (
                    <div
                      key={`line-${index}`}
                      style={{
                        flex: "1 1 auto",
                        height: "2px",
                        backgroundColor: steps[index + 1].active
                          ? "#5fc4d9"
                          : "#e0e0e0",
                      }}
                    />
                  )}
                </Fragment>
              ))}
            </div>

            {/* Labels row */}
            <div className="d-flex justify-content-between">
              {steps.map((step, index) => (
                <div
                  key={`label-${index}`}
                  className="text-center"
                  style={{ width: "4rem" }}
                >
                  <div className="fw-semibold" style={{ fontSize: "14px" }}>
                    {step.label}
                  </div>
                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    {step.date}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Steps container - Mobile */}
          <div className="d-md-none d-flex flex-column gap-5">
            {steps.map((step, index) => (
              <div key={index} className="text-center position-relative">
                {/* Step icon */}
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2 fs-2"
                  style={{
                    width: "4rem",
                    height: "4rem",
                    backgroundColor: step.color,
                    color: "white",
                    zIndex: 2,
                  }}
                >
                  {iconMap[step.iconName]}
                </div>

                {/* Step content */}
                <div>
                  <div className="fw-semibold" style={{ fontSize: "14px" }}>
                    {step.label}
                  </div>
                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    {step.date}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
